const { theme } = require('antd')
const React = require('react')
const resolvePath = (path) => require('path').resolve(__dirname, path)

// 加了react-loadable配置
// 客户端路由配置
module.exports = {
  type: 'ssr', // 指定运行类型可设置为csr切换为客户端渲染
  routes: [
    {
      path: '/',
      exact: true,
      Component: () => require('@/page/index').default, // 这里使用一个function包裹为了让它延迟require
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/news',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () => import(/* webpackChunkName: "news" */ '@/page/news'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/news').default,
      controller: 'news',
      handler: 'index',
    },
    {
      path: '/newDetail/:id',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () => import(/* webpackChunkName: "news" */ '@/page/news/newDetail'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/news/newDetail').default,
      controller: 'news',
      handler: 'index',
    },
    {
      path: '/about',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () => import(/* webpackChunkName: "confirmWeigh" */ '@/page/about'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/about').default,
      controller: 'about',
      handler: 'index',
    },
    {
      path: '/about/team',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () => import(/* webpackChunkName: "confirmWeigh" */ '@/page/about/team'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/about/team').default,
      controller: 'team',
      handler: 'index',
    },
    {
      path: '/about/join',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () => import(/* webpackChunkName: "confirmWeigh" */ '@/page/about/join'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/about/join').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/about/joinDetail/:id',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/about/joinDetail'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/about/joinDetail').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/about/honor',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () => import(/* webpackChunkName: "confirmWeigh" */ '@/page/about/honor'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/about/honor').default,
      controller: 'honor',
      handler: 'index',
    },
    {
      path: '/product/tritium',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () => import(/* webpackChunkName: "confirmWeigh" */ '@/page/product/tritium'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/product/tritium').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/product/distressed',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/product/distressed'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/product/distressed').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/product/baoquan',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
              loader: () => import(/* webpackChunkName: "confirmWeigh" */ '@/page/product/bqw'),
              loading: function Loading() {
                return React.createElement('div')
              },
            })
          : require('@/page/product/bqw').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/product/cap',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () => import(/* webpackChunkName: "confirmWeigh" */ '@/page/product/cap'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/product/cap').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/product/dataplatform',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/product/dataplatform'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/product/dataplatform').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/product/jinzong',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () => import(/* webpackChunkName: "confirmWeigh" */ '@/page/product/jinzong'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/product/jinzong').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/achievements/academy',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () => import(/* webpackChunkName: "confirmWeigh" */ '@/page/achievements/academy'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/achievements/academy').default,
      controller: 'academy',
      handler: 'index',
      showHomeJoin: false,
      theme: 'dark'
    },
    {
      path: '/achievements/hybridchain',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/achievements/hybridchain'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/achievements/hybridchain').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/solution/government',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/solution/government'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/solution/government').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/solution/judicial',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/solution/judicial'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/solution/judicial').default,
      // Component: () => (require('@/page/confirmWeigh').default),
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/solution/collection',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/solution/collection'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/solution/collection').default,
      // Component: () => (require('@/page/confirmWeigh').default),
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/solution/traceability',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/solution/traceability'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/solution/traceability').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/solution/finance',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () => import(/* webpackChunkName: "confirmWeigh" */ '@/page/solution/finance'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/solution/finance').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/solution/propertyRight',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/solution/propertyRight'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/solution/propertyRight').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/solution/dataAssets',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/solution/dataAssets'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/solution/dataAssets').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/solution/mediation',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/solution/mediation'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/solution/mediation').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/solution/publicWelfare',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/solution/publicWelfare'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/solution/publicWelfare').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/solution/education',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/solution/education'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/solution/education').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/solution/medical',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/solution/medical'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/solution/medical').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/solution/agriculture',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/solution/agriculture'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/solution/agriculture').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/disclaimer',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () => import(/* webpackChunkName: "confirmWeigh" */ '@/page/disclaimer'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/disclaimer').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/trustedDataCirculation',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/trustedDataCirculation'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/trustedDataCirculation').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/industryApplications/mediation',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/industryApplications/mediation'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/industryApplications/mediation').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/industryApplications/digitalPassport',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/industryApplications/digitalPassport'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/industryApplications/digitalPassport').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/industryApplications/digitalAssets',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/industryApplications/digitalAssets'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/industryApplications/digitalAssets').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/industryApplications/dataAssets',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/industryApplications/dataAssets'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/industryApplications/dataAssets').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/industryApplications/jinzong',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/industryApplications/jinzong'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/industryApplications/jinzong').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/industryApplications/digitalJustice',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/industryApplications/digitalJustice'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/industryApplications/digitalJustice').default,
      controller: 'page',
      handler: 'index',
    },
    {
      path: '/coreCompetencies',
      exact: true,
      Component: () =>
        __isBrowser__
          ? require('react-loadable')({
            loader: () =>
              import(/* webpackChunkName: "confirmWeigh" */ '@/page/coreCompetencies'),
            loading: function Loading() {
              return React.createElement('div')
            },
          })
          : require('@/page/coreCompetencies').default,
      controller: 'page',
      handler: 'index',
    },
  ],
  baseDir: resolvePath('../'),
  injectCss: [
    `/static/css/Page.chunk.css`,
    `//at.alicdn.com/t/font_1833892_c24ob5pn9m.css`,
    // `//at.alicdn.com/t/font_1520691_cp7527e9h0g.css` // 加入icon动态地址
  ], // 客户端需要加载的静态样式表
  injectScript: [
    `<script src='/static/js/runtime~Page.js'></script>`,
    `<script src='/static/js/vendor.chunk.js'></script>`,
    `<script src='/static/js/Page.chunk.js'></script>`,
    // `<script src='https://dataqin.oss-cn-hangzhou.aliyuncs.com/home_cg%203/lottie.js'></script>`,
    // `<script src="https://cdnjs.com/libraries/bodymovin" type="text/javascript"></script>`,
    `<script src='https://at.alicdn.com/t/font_1739738_r8msi0djo8e.js'></script>`,
    ` <script src="https://webapi.amap.com/maps?v=1.4.10&key=10c08c88c635030c0c74b9104ce292ba"></script>`,
  ], // 客户端需要加载的静态资源文件表
  serverJs: resolvePath(`../dist/Page.server.js`),
  layout: resolvePath(`../dist/Layout.server.js`),
  useCDN: false,
}
